import styled from 'styled-components';
import RewardBonusSvg from '../../assets/wallet/ic-reward-bonus.svg';

const RewardBonusIcon = styled(RewardBonusSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
    width: ${props => props.width || '3.5rem'};
    height: ${props => props.height || '3.5rem'};
`;

export default RewardBonusIcon;
